module.exports = __webpack_public_path__ + "img/kufri-grey.77e758e.webp";